const $navbar = $('#nav');
const navbarHeight = $navbar.outerHeight();
const $summaryAside = $('#summary-aside');
const $catalogList = $('#catalog-list');
let catalogListHeight = $catalogList.outerHeight();
const summaryAsideHeight = $summaryAside.outerHeight();
const catalogListTop = $catalogList.offset().top;
const catalogItemList = {};
let scrollTop = $(document).scrollTop();
const $mobileToggle = $('#mobile-toggle');
const $mobileToggleHeight = $mobileToggle.outerHeight();
const mobileToggleTop = $mobileToggle.offset().top;
const $mobileMenu = $('#mobile-menu');

const indexCatalogList = () => {
    $('.summary-link').each((index, $elem) => {
        let $section = $($($elem).data('anchor'));
        let sectionMiddleTop = _.round($section.offset().top + ($section.parent().outerHeight() / 3));
        catalogItemList[sectionMiddleTop] = '#' + $section.attr('id');
    });
    catalogListHeight = $catalogList.outerHeight();
};

$(window).ready(() => {
    indexCatalogList();
    setTimeout(indexCatalogList, 500);

    /**
     *  make aside follow the scroll
     */
    const asideScrollPosition = () => {

        let navSide = $('#summary-aside');

        if (navSide.height() > (0.80*$(window).height())) {
            navSide.addClass('compact');
        }

        let navHeight = $('#nav').height();
        let fixedStep = $('#catalog-list').offset().top - 10;
        let navSideBottomStep= navSide.height() + navHeight + 60 + $(document).scrollTop();

        if (($(document).scrollTop() + navHeight) > fixedStep) {
            navSide.addClass('fixed');
        } else {
            navSide.removeClass('fixed');
        }

        if (navSideBottomStep > $('#footer').offset().top) {
            navSide.addClass('bottom-reached');
        } else {
            navSide.removeClass('bottom-reached');
        }
    };

    const summaryActive = () => {

        let titles = $('#catalog-list h2');
        let currentSelection = titles.first();
        let selTolerance = $('#nav').height() + $('#mobile-toggle').height() + 100;
        let selStep = ($(window).scrollTop() + selTolerance);
        let endStep = $(document).height() - $(window).height() - 5;

        //if we can't scroll anymore, the last item is selected
        if ($(window).scrollTop() >= endStep) {
            currentSelection = titles.last();
        } else {
            $('#catalog-list h2').each(function () {
                if ($(this).offset().top < selStep) {
                    currentSelection = $(this);
                }
            });
        }

        titles.removeAttr('data-selected');
        currentSelection.attr('data-selected', 'true');

        $('#summary-aside [data-anchor], #mobile-toggle [data-anchor]').find('svg').removeClass('text-dark');
        let activeTab = $('#summary-aside [data-anchor=\'#' + currentSelection.attr('id') + '\']');
        let activeTabMobile = $('#mobile-toggle [data-anchor=\'#' + currentSelection.attr('id') + '\']');
        activeTab.find('svg').addClass('text-dark');
        activeTabMobile.find('svg').addClass('text-dark');

        return activeTab;
    };

    const stickMobileToggle = () => {
        if (window.pageYOffset > mobileToggleTop - navbarHeight) {
            $mobileToggle.addClass('sticky');
            $mobileMenu.css('top', window.pageYOffset + navbarHeight + $mobileToggleHeight - mobileToggleTop - 4);
        } else {
            $mobileToggle.removeClass('sticky');
            $mobileMenu.css('top', '');
        }
    };

    const setNavBg = window.onscroll;
    const scrollAnimations = () => {
        scrollTop = $(document).scrollTop();
        if (window.matchMedia('(max-width: 991px)').matches) {
            stickMobileToggle();
            $('.dropdown-menu.show').removeClass('show');
        } else {
            asideScrollPosition();
        }
        let sectionActive = summaryActive();
        if (window.matchMedia('(max-width: 991px)').matches) {
            $('#selected-mobile-item').text($(sectionActive).text());
        }
        setNavBg();
    };

    // listen scroll event to make aside follow scroll
    window.onscroll = scrollAnimations;
    $summaryAside.find('.summary-link').click(event => {
        scrollToAnchor($($(event.currentTarget).data('anchor')));
    });

    const getLinkAnchor = () => {
        let anchor = ((document.URL).split('#'))[1];
        if (anchor) {
            let  anchorLink = $('[data-anchor=\'#'+anchor+'\']');
            if (anchorLink.length) {
                $('html, body').animate({
                    scrollTop: $('#'+anchor).offset().top - 150
                }, 0);
            }else{
                scrollToAnchor($('#'+anchor));
            }
        }
    };

    const scrollToAnchor = (anchor) => {
        $('html, body').animate({
            scrollTop: anchor.offset().top - 150
        }, 300, () => {
            scrollAnimations();
        });
    };

    $('.mobile-item').click(event => {
        scrollToAnchor($($(event.currentTarget).data('anchor')));
    });

    scrollAnimations();
    getLinkAnchor();

    setTimeout(scrollAnimations, 500);
});
